import { Flex } from '@applyboard/crystal-ui';
import { GradeConversionCreateForm } from '../components/GradeConversionCreateForm';
import { GradeConversionCreateHeading } from '../components/GradeConversionCreateHeading';
import { GradeConversionCreateLayoutProps } from './types';

export function DesktopLayout({
  gradeSchemas,
  gradePointMappings,
  educationLevels,
  countries,
}: GradeConversionCreateLayoutProps) {
  return (
    <Flex p={10} gap={8} direction="column">
      <GradeConversionCreateHeading />
      <GradeConversionCreateForm
        gradeSchemas={gradeSchemas}
        gradePointMappings={gradePointMappings}
        educationLevels={educationLevels}
        countries={countries}
      />
    </Flex>
  );
}
